import './LabelList.svelte.css';
/* src/components/searchList/LabelList.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	destroy_each,
	detach,
	element,
	empty,
	init,
	insert,
	noop,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../../../_snowpack/pkg/svelte.js';
import { defaultParams } from '../../stores/storeInputOptions.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[7] = list[i];
	return child_ctx;
}

// (25:0) {#if labelList && Object.keys(labelList).length}
function create_if_block(ctx) {
	let ul;
	let each_value = /*labelList*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(ul, "class", "label-list svelte-1rbbsqk");
			set_style(ul, "background-image", "url(" + /*bg*/ ctx[3] + ")");
		},
		m(target, anchor) {
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}
		},
		p(ctx, dirty) {
			if (dirty & /*url, labelList, urlimg, getX*/ 23) {
				each_value = /*labelList*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (27:2) {#each labelList as label}
function create_each_block(ctx) {
	let li;
	let a;
	let t0_value = /*label*/ ctx[7].name + "";
	let t0;
	let a_href_value;
	let t1;

	return {
		c() {
			li = element("li");
			a = element("a");
			t0 = text(t0_value);
			t1 = space();
			attr(a, "href", a_href_value = "" + (/*url*/ ctx[0] + "/" + /*label*/ ctx[7].labelTypeSlug + "/" + /*label*/ ctx[7].slug));
			set_style(a, "background-image", "url(" + /*urlimg*/ ctx[1] + "/" + /*label*/ ctx[7].labelTypeSlug + "/photo_categorySearch_" + /*label*/ ctx[7].labelTypeSlug + ".webp)");
			set_style(a, "background-position-x", "-" + /*getX*/ ctx[4]() + "px");
			attr(a, "class", "svelte-1rbbsqk");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, a);
			append(a, t0);
			append(li, t1);
		},
		p(ctx, dirty) {
			if (dirty & /*labelList*/ 4 && t0_value !== (t0_value = /*label*/ ctx[7].name + "")) set_data(t0, t0_value);

			if (dirty & /*url, labelList*/ 5 && a_href_value !== (a_href_value = "" + (/*url*/ ctx[0] + "/" + /*label*/ ctx[7].labelTypeSlug + "/" + /*label*/ ctx[7].slug))) {
				attr(a, "href", a_href_value);
			}

			if (dirty & /*urlimg, labelList*/ 6) {
				set_style(a, "background-image", "url(" + /*urlimg*/ ctx[1] + "/" + /*label*/ ctx[7].labelTypeSlug + "/photo_categorySearch_" + /*label*/ ctx[7].labelTypeSlug + ".webp)");
			}
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

function create_fragment(ctx) {
	let show_if = /*labelList*/ ctx[2] && Object.keys(/*labelList*/ ctx[2]).length;
	let if_block_anchor;
	let if_block = show_if && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
		},
		p(ctx, [dirty]) {
			if (dirty & /*labelList*/ 4) show_if = /*labelList*/ ctx[2] && Object.keys(/*labelList*/ ctx[2]).length;

			if (show_if) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $defaultParams;
	component_subscribe($$self, defaultParams, $$value => $$invalidate(6, $defaultParams = $$value));
	let { url } = $$props;
	let { urlimg } = $$props;
	let labelList = {};
	let position_x = 0;
	const bg = urlimg + '/common/bg_categorySearch_ul.webp';

	onMount(() => {
		$$invalidate(2, labelList = $defaultParams.labellist);
	});

	const getX = () => {
		let ret = position_x;
		position_x = position_x + 159;
		return ret;
	};

	$$self.$$set = $$props => {
		if ('url' in $$props) $$invalidate(0, url = $$props.url);
		if ('urlimg' in $$props) $$invalidate(1, urlimg = $$props.urlimg);
	};

	return [url, urlimg, labelList, bg, getX];
}

class LabelList extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { url: 0, urlimg: 1 });
	}
}

export default LabelList;